import React from 'react';

import { AiOutlineWhatsApp } from 'react-icons/ai'
import LogoIcon from '../images/logo_icon.png';
import "./MovingIcon.css";


const MovingIcon = ({ whatsapp }) => {


  return (
    <div className='mt-4'>
      <div className=" flex justify-center">
        {/* <a href='https://wa.me/+972523501894' className='flex flex-col justify-center items-center w-[100px] h-[100px]'>
          <div className="group flex items-center justify-center w-12 h-12 rounded-full bg-secondary hover:scale-[110%] duration-200">
            <div className="group-hover:scale-[110%]">
              <AiOutlineWhatsApp size={30} color='white' />
            </div>
          </div>
        </a> */}
        <a href={`https://wa.me/${whatsapp}`} target="_blank" className='flex flex-col justify-center items-center hover:scale-125 duration-300 h-[200px] w-[200px]'>
          <img src={LogoIcon} alt="logoIcon" className='  border-gray-400  shake-animation' style={{ width: '200px',  }} />
        </a>
      </div>
    </div>
  );
};

export default MovingIcon;
